module.exports = __webpack_public_path__ + "static/img/news5_1.a5e1017.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news5_1.jpg
// module id = 4rtP
// module chunks = 0